<template>
  <MainWrapper>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3 class="mb-30">Стать специалистом</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="white-panel pt-20 pb-20 pr-20 pl-20">
              <div class="container-fluid">
                <div class="row">
                  <div class="tabs mb-30">
                    <router-link
                      :to="'/user/become-a-specialist'"
                      class="tab pb-15 mr-30 inline-block"
                    >
                      <h4 @click="tab = 'main'">Основные настройки</h4>
                    </router-link>
                    <div class="light-gray-line"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 no-p">
                    <p class="dark-body-text mb-10">Данные специалиста</p>
                    <p
                      class="mb-30"
                    >Заполните все поля. Это необходимое условие для записи к специалистам и обеспечению безопасности вашей учетной записи.</p>
                    <!--
                                    <div class="spec-photo mb-10" :style="{'background-image': `url(//checkin.kg${this.photo})`}"></div>
                                    <input type="file" @change="pickPhoto($event.target.name, $event.target.files)" id="photo-upload" accept="image/*" class="input-file">
                    -->
                    <img
                      v-if="master.photo !== ''"
                      :src="master.photo"
                      class="mb-15"
                      style="width:200px;height:200px"
                    />
                    <p
                      class="mb-15"
                    >Фото вашего профиля будет отображаться на странице специалистов и на вашей персональной странице.</p>

                    <avatar-cropper
                      :labels="userAvatarLabels"
                      @uploaded="handleUploaded"
                      trigger="#pick-avatar"
                      :upload-url="siteUrl+'/content/upload/photo'"
                    />
                    <div class="button-wrapper mb-15">
                      <Button id="pick-avatar" type="gray" class="mr-10" text="Загрузить" />
                    </div>

                    <!--
                                    <div class="button-wrapper mb-15">
                                        <label for="photo-upload"><Button type="gray" class="mr-10" text="Загрузить"  /></label>
                                    </div>
                    -->
                    <!--
                                    <div class="input-wrapper mb-10">
                                        <input class="rounded-input" type="text" v-model="master.full_name" placeholder="Иванов Иван" />
                                    </div>
                                    <div class="input-wrapper mb-10">
                                        <select v-model="master.sex" class="rounded-input">
                                            <option value="">Выберите</option>
                                            <option v-if="master.sex == 'Мужской'" value="Мужской" selected>Мужской</option>
                                            <option v-else value="Мужской">Мужской</option>
                                            <option v-if="master.sex == 'Женский'" value="Женский" selected>Женский</option>
                                            <option v-else value="Женский">Женский</option>
                                        </select>
                                    </div>
                                    <div class="input-wrapper mb-10">
                                        <input v-model="master.birth_date" class="rounded-input" type="date" placeholder="" />
                                    </div>
                                    <div class="input-wrapper mb-10">
                                        <input class="rounded-input" type="mail" v-model="master.email" placeholder="example@example.com" />
                                    </div>
                                    <div class="input-wrapper mb-15" v-for="(p, i) in master.specialist_contacts" :key="i">
                                        <input class="rounded-input mr-15" type="tel" v-model="p.phone" mask="996" placeholder="+996 556 088 891" />
                                    </div>
                    -->
                    <!--div class="button-wrapper mb-15">
                                        <Button type="gray" class="mr-10" text="Добавить номер" @click="master.specialist_contacts.push({ phone: '' })" />
                    </div-->
                    <p class="gray-body-text mb-15">Ваш адрес</p>
                    <div class="input-wrapper mb-30">
                      <!--<cascading-address></cascading-address>-->
                      <select v-model="addr_a" class="rounded-input mr-10" style="width:150px;">
                        <option value selected disabled>Выберите</option>
                        <option value="Бишкек">Бишкек</option>
                        <option value="Кант">Кант</option>
                      </select>
                      <input
                        v-model="addr_b"
                        class="rounded-input mr-10"
                        type="text"
                        placeholder="Район или улица"
                      />
                      <input
                        v-model="addr_c"
                        class="rounded-input"
                        type="text"
                        placeholder="№ дома"
                        style="width:100px"
                      />
                    </div>
                    <!---->
                    <!--<textarea class="mb-15" placeholder="г. Бишкек ул. Исанова 70а" v-model="master.street_address"></textarea>-->
                    <p
                      class="gray-body-text mb-15"
                    >Краткое описание отображается на странице всех специалистов</p>
                    <vue-editor
                      id="short_info"
                      v-model="master.short_info"
                      :editorToolbar="customToolbar"
                      class="mb-15"
                      placeholder="Краткое описание ваших услуг"
                    ></vue-editor>
                    <!--<textarea class="mb-15" placeholder="Краткое описание ваших услуг" v-model="master.short_info"></textarea>-->
                    <p class="gray-body-text mb-15">Полное описание отображается у вас на странице</p>
                    <vue-editor
                      id="full_info"
                      v-model="master.full_info"
                      :editorToolbar="customToolbar"
                      class="mb-15"
                      placeholder="Полное описание ваших услуг"
                    ></vue-editor>
                    <!--<textarea class="mb-15" placeholder="Полное описание ваших услуг" v-model="master.full_info"></textarea>-->
                    <p class="gray-body-text mb-15">Укажите вашу специальность</p>

                    <div
                      v-if="master.categories.length > 0"
                      class="input-wrapper mb-10"
                      v-for="item, i in master.categories"
                      :key="item.id"
                    >
                      <input
                        class="rounded-input mr-15"
                        style="background:#e0e0e0"
                        type="text"
                        :value="item.name"
                        disabled
                      />
                      <span @click="unsetCategories(i)" class="red-body-text pointer">Удалить</span>
                    </div>

                    <!-- <div class="input-wrapper">
                      <treeselect
                        :multiple="true"
                        :options="options"
                        :load-options="loadOptions"
                        :close-on-select="true"
                        :disable-branch-nodes="true"
                        :auto-load-root-options="false"
                        placeholder="Выберите"
                        v-model="selectedValues"
                      />
                    </div> -->

                    <div class="input-wrapper">
                                        <select class="rounded-input" v-model="cat_level1" @change="setCategoriesLevel2()">
                                            <option value="0" disabled>Выберите категорию</option>
                                            <option v-for="cat, i in categories" :key="cat.id" :value="cat.slug">{{ cat.name }}</option>
                                        </select>
                                    </div>
                                    <div v-if="level2.length > 0" class="input-wrapper mt-10">
                                        <select class="rounded-input" v-model="cat_level2" @change="setCategoriesLevel3()">
                                            <option value="0" disabled>Выберите категорию</option>
                                            <option v-for="cat, i in level2" :key="cat.id" :value="cat.slug">{{ cat.name }}</option>
                                        </select>
                                    </div>
                                    <div v-if="level3.length > 0" class="input-wrapper mt-10">
                                        <select class="rounded-input" v-model="cat_level3" @change="setCategories()">
                                            <option value="0" disabled>Выберите категорию</option>
                                            <option v-for="cat, i in level3" :key="cat.id" :value="cat.id+':::'+cat.name+':::'+cat.slug">{{ cat.name }}</option>
                                        </select>
                    </div>
                    <p class="gray-body-text mt-30 mb-15">Список ваших услуг</p>
                    <div class="input-wrapper mb-10">
                      <div
                        class="dark-body-text"
                        style="display:inline-block;width:255px"
                      >Тип сервиса</div>
                      <div
                        class="dark-body-text ml-10"
                        style="display:inline-block;width:100px"
                      >Время</div>
                      <span class="dark-body-text ml-10">Стоимость</span>
                    </div>
                    <div class="input-wrapper mb-10" v-for="item,k in master.service" :key="k">
                      <input v-model="master.service[k].name" class="rounded-input" type="text" />
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="master.service[k].duration"
                        class="rounded-input ml-10"
                        style="width:100px"
                      ></vue-timepicker>
                      <!--
                                        <select v-model="master.service[k].duration.substr(0,5)" class="rounded-input ml-10" style="width:100px" placeholder="Укажите длительность">
                                            <option value="00:15">00:15</option>
                                            <option value="00:30">00:30</option>
                                            <option value="00:45">00:45</option>
                                            <option value="01:00">01:00</option>
                                        </select>
                      -->
                      <input
                        v-model="master.service[k].price"
                        class="rounded-input ml-10 mr-15"
                        style="width:120px"
                        type="text"
                        placeholder="Стоимость"
                      />
                      <span @click="unsetService(k)" class="red-body-text pointer">Удалить</span>
                    </div>
                    <hr v-if="master.service.length > 0" />
                    <div class="input-wrapper mb-15">
                      <input
                        v-model="service_title"
                        class="rounded-input"
                        type="text"
                        placeholder="Тип сервиса"
                      />
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="service_duration"
                        class="rounded-input ml-10"
                        style="width:100px"
                      ></vue-timepicker>
                      <!--
                                        <select v-model="service_duration" class="rounded-input ml-10" style="width:100px" placeholder="Укажите длительность">
                                            <option value="00:15">00:15</option>
                                            <option value="00:30">00:30</option>
                                            <option value="00:45">00:45</option>
                                            <option value="01:00">01:00</option>
                                        </select>
                      -->
                      <input
                        v-model="service_price"
                        class="rounded-input ml-10"
                        style="width:120px"
                        type="text"
                        placeholder="Стоимость"
                      />
                    </div>
                    <div class="button-wrapper mb-30">
                      <Button @click="setService" style="width:135px" type="gray" text="Добавить" />
                    </div>
                    <CustomMap
                      :lat="this.master.latitude"
                      :lng="this.master.longitude"
                      :center="{ lat: 42.8717873, lng: 74.6131377 }"
                      @setGeolocation="handleLocation"
                    />
                    <p class="gray-body-text mb-15">Ваши сертификаты</p>
                    <div v-if="master.specialist_certificate.length > 0" class="mb-15">
                      <div
                        class="mr-15"
                        v-for="s,i in master.specialist_certificate"
                        :key="i"
                        style="display:inline-block"
                      >
                        <a :href="s.url" target="_blank">
                          <img style="height:170px" :src="s.url" />
                        </a>
                        <p style="cursor:pointer" @click="unsetSertificate(i)">Удалить</p>
                      </div>
                    </div>
                    <input
                      type="file"
                      @change="setSertificate($event.target.files)"
                      id="sertificate-upload"
                      accept="image/*"
                      class="input-file"
                    />
                    <div class="input-wrapper mb-30">
                      <label for="sertificate-upload">
                        <Button type="gray" class="mr-10" text="Загрузить" />
                      </label>
                    </div>
                    <p class="gray-body-text mb-15">Ваше портфолио</p>
                    <div v-if="master.specialist_portfolio.length > 0" class="mb-15">
                      <div
                        class="mr-15"
                        v-for="p,i in master.specialist_portfolio"
                        :key="i"
                        style="display:inline-block"
                      >
                        <a :href="p.url" target="_blank">
                          <img style="height:170px" :src="p.url" />
                        </a>
                        <p style="cursor:pointer" @click="unsetPortfolio(i)">Удалить</p>
                      </div>
                    </div>
                    <input
                      type="file"
                      @change="setPortfolio($event.target.files)"
                      id="portfolio-upload"
                      accept="image/*"
                      class="input-file"
                    />
                    <div class="input-wrapper mb-30">
                      <label for="portfolio-upload">
                        <Button type="gray" class="mr-10" text="Загрузить" />
                      </label>
                    </div>
                    <div class="button-wrapper mt-30">
                      <Button type="blue" text="Сохранить" @click="createMaster" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.icon {
  font-size: 18px;
}

.single-filter {
  display: inline-flex;
  align-items: center;

  .filter-icon {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 1px solid cyan_dark_color;
    color: cyan_dark_color;
  }
}

.spec-photo {
  width: 70px;
  height: 70px;
  background: #ccc;
  border-radius: 100%;
  background-size: cover;
}

textarea {
  border-radius: 8px;
  border: 1px solid $light_gray;
  padding: 10px 15px;
  width: 500px;
  max-width: 100%;
  min-height: 150px;
}

input[type='file'] {
  display: none;
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import Treeselect from "@riophae/vue-treeselect";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import News from "@/components/News.vue";
import Paginator from "@/components/Paginator.vue";
import VueTimepicker from "vue2-timepicker";
import http from "@/methods/http.ts";
import * as VueGoogleMaps from "vue2-google-maps";
import axios from "axios";
import AvatarCropper from "vue-avatar-cropper";
import cascadingAddress from "@/components/AddressList.vue";
import CustomMap from "@/components/CustomMap";
import { VueEditor } from "vue2-editor";
import { mapState } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    MainWrapper,
    Button,
    News,
    Paginator,
    VueTimepicker,
    AvatarCropper,
    cascadingAddress,
    VueEditor,
    CustomMap,
    Treeselect
  },
  computed: mapState(["authenticated"]),
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.authenticated) {
        return true;
      }
      console.log({ to, from, vm });
      setTimeout(() => {
        vm.$store.commit("notificate", {
          text: "Авторизуйтесь для доступа к этой странице",
          type: "error"
        });
      }, 500);
      vm.$router.push(from.path);
    });
  }
})
export default class CreateSpecialist extends Vue {
  component = this;

  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    };
  }

  tab = 2;

  siteUrl = "";

  addr_a = "";
  addr_b = "";
  addr_c = "";

  photo = "";
  categories = [];
  level2 = [];
  level3 = [];
  cats = 0;
  cat_level1 = 0;
  cat_level2 = 0;
  cat_level3 = 0;

  service_title = "";
  service_duration = { HH: null, mm: null };
  service_price = "";

  userAvatarLabels = { submit: "Сохранить", cancel: "Отменить" };

  master = {
    photo: "",
    categories: [],
    email: "",
    full_info: "",
    birth_date: "",
    service: [],
    specialist_certificate: [],
    specialist_portfolio: [],
    specialist_contacts: [
      {
        phone: ""
      }
    ],
    street_address: "",
    sex: "",
    full_name: "",
    avatar: 0,
    short_info: "",
    latitude: "",
    longitude: ""
  };

  selectedValues = [];
  options = []

  //hooks

  unsetPortfolio(k) {
    this.master.specialist_portfolio.splice(k, 1);
    //this.$store.commit('notificate', { text: 'Портфолио обновлено', type: 'action' });
  }

  setPortfolio(files) {
    let data = new FormData();
    data.append("file", files[0]);

    http("content/upload/portfolio", "post", this.$store.state.token, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(r => {
        if (r.data.success === true) {
          this.master.specialist_portfolio.push({
            id: r.data.id,
            url: r.data.url
          });
          this.$store.commit("notificate", {
            text: "Портфолио обновлено",
            type: "action"
          });
        }
      })
      .catch(r => {
        this.$store.commit("notificate", {
          text: "Введены неверные данные",
          type: "error"
        });
      });
  }

  unsetSertificate(k) {
    this.master.specialist_certificate.splice(k, 1);
    //this.$store.commit('notificate', { text: 'Сертификаты обновлены', type: 'action' });
  }

  setSertificate(files) {
    let data = new FormData();
    data.append("file", files[0]);
    http("content/upload/certificate", "post", this.$store.state.token, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(r => {
        if (r.data.success === true) {
          this.master.specialist_certificate.push({
            file_ptr_id: 1, //r.data.file_ptr_id,
            url: r.data.url
          });
          this.$store.commit("notificate", {
            text: "Сертификаты обновлены",
            type: "action"
          });
        }
      })
      .catch(r => {
        this.$store.commit("notificate", {
          text: "Введены неверные данные",
          type: "error"
        });
      });
  }

  handleUploaded(resp) {
    this.master.photo = resp.url;
  }

  unsetCategories(idx) {
    this.master.categories.splice(idx, 1);
  }

  setCategories() {
    let params = this.cat_level3;
    params = params.split(":::");

    this.master.categories.push({
      id: params[0],
      name: params[1],
      slug: params[2]
    });
    this.cat_level1 = 0;
    this.cat_level2 = 0;
    this.cat_level3 = 0;
    this.level2 = [];
    this.level3 = [];
  }

  setCategoriesLevel2() {
    this.cat_level2 = 0;
    this.cat_level3 = 0;
    this.level2 = [];
    this.level3 = [];
    let url = "categories/" + this.cat_level1;
    http(url, "get", false, {}).then(r => {
      this.level2 = r.data.children;
    });
  }

  setCategoriesLevel3() {
    let url = "categories/" + this.cat_level2;
    http(url, "get", false, {}).then(r => {
      this.level3 = r.data.children;
    });
  }

  pickPhoto(names, files) {
    let pk = this.master.user;
    let data = new FormData();

    data.append("file", files[0]);

    axios
      .post(`https://checkin.kg/api/v1/master/${pk}/photo/`, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(r => {
        if (r.data.success === true) {
          this.photo = r.data.url;
          this.$store.commit("notificate", {
            text: "Фото профиля обновлено",
            type: "action"
          });
        }
      })
      .catch(r => {
        this.$store.commit("notificate", {
          text: "Введены неверные данные",
          type: "error"
        });
      });
  }

  setService() {
    if (this.service_title === "") {
      this.$store.commit("notificate", {
        text: "service_title is empty",
        type: "error"
      });
      return false;
    }
    if (
      this.service_duration.HH === null ||
      this.service_duration.HH === "" ||
      this.service_duration.mm === null || this.service_duration.mm === ""
    ) {
      this.$store.commit("notificate", {
        text: "service_duration is empty",
        type: "error"
      });
      return false;
    }
    if (this.service_price === "") {
      this.$store.commit("notificate", {
        text: "service_price is empty",
        type: "error"
      });
      return false;
    }
    this.master.service.push({
      name: this.service_title,
      duration: this.service_duration,
      price: this.service_price
    });
    this.service_title = "";
    this.service_duration = { HH: null, mm: null };
    this.service_price = "";
  }

  unsetService(idx) {
    this.master.service.splice(idx, 1);
  }

  createMaster() {
    if (this.addr_a === "" || this.addr_b === "" || this.addr_c === "") {
      this.$store.commit("notificate", {
        text: "street_address data error",
        type: "error"
      });
      return false;
    }
    this.master.street_address =
      this.addr_a + ":::::" + this.addr_b + ":::::" + this.addr_c;
    http("master/create", "post", this.$store.state.token, this.master)
      .then(r => {
        if (r.data.success === true) {
          this.$router.push("/specialist/settings");
        }
      })
      .catch(error => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error"
        });
      });
  }

  getCategories() {
    http("categories/main", "get", false, {}).then(r => {
      this.categories = r.data;
      this.options = this.buildOptions(r.data);
    });
  }

  getUserInfo() {
    http("user/info", "get", this.$store.state.token, {}).then(r => {
      this.master.full_name = r.data.full_name;
      this.master.email = r.data.email;
      this.master.user = r.data.user_ptr_id;
      this.master.specialist_contacts[0].phone = r.data.phone;
      this.master.sex = r.data.sex;
      if (r.data.birth_date) {
        let birth_date = r.data.birth_date;
        birth_date = birth_date.split(".");
        this.master.birth_date =
          birth_date[2] + "-" + birth_date[1] + "-" + birth_date[0];
      }
    });
  }

  async loadOptions({ parentNode, callback }) {
      const res = await http(`categories/${parentNode.slug}`, "get", false, {})
      parentNode.children = this.buildOptions(res.data);
      const parentOption = this.options.find(option => option.id === parentNode.id );
      parentOption.children = this.buildOptions(res.data);
      console.log({ options: this.options })
      callback()
  }

  // loadOptions({ action, parentNode, callback }) {
  //   http(`categories/${parentNode.slug}`, "get", false, {})
  //     .then(res => {
  //       parentNode.children = this.buildOptions(res.data, false);
  //       console.log({ action, parentNode, data: res.data })
  //       return callback()
  //     })
  //     .finally(() => callback())
  // }

  buildOptions(data, hasChild = true) {
    data.label = data.name;
    data.children = data.children.map(child => {
        child.label = child.name;
        if (hasChild) child.children = null
        return child;
    })
    return data.children
  }

  mounted() {
    if (window.location.hostname === "localhost") {
      this.siteUrl = "http://api.checkin.local/api/v1";
    } else {
      this.siteUrl = "https://api.checkin.kg/api/v1";
    }
    this.getUserInfo();
    this.getCategories();
  }

  handleLocation({ lat, lng }) {
    console.group("handleLocation");
    this.master.latitude = lat;
    this.master.longitude = lng;
    console.log("updated master", this.master);
    this.$store.commit("notificate", {
      text: "Ваше местоположение добавлено!",
      type: "action"
    });
  }
}
</script>